import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CreateUserDialogComponent } from '../dialogs/create-user-dialog/create-user-dialog.component';
import { DeleteUserDialogComponent } from '../dialogs/delete-user-dialog/delete-user-dialog.component';
import { DialogContainerComponent } from '../../common-panel/components/dialog-container/dialog-container.component';
import { EditUserDialogComponent } from '../dialogs/edit-user-dialog/edit-user-dialog.component';
import { ReviewCreateUserDialogComponent } from '../dialogs/review-create-user-dialog/review-create-user-dialog.component';
import { ReviewEditUserDialogComponent } from '../dialogs/review-edit-user-dialog/review-edit-user-dialog.component';
import { SelectClinicsDialogComponent } from '../dialogs/select-clinics-dialog/select-clinics-dialog.component';
import { ResetUserPasswordDialogComponent } from '../dialogs/reset-user-password-dialog/reset-user-password-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class DialogsManagerService
{
  isGoBack: boolean = false
  
  constructor(public dialog: MatDialog) { }


  showCreateUserDialogComponent()
  {
    this.dialog.open(DialogContainerComponent,
      {
        disableClose: true,
        // maxHeight: '90vh',
        minWidth: "42em",
        data: CreateUserDialogComponent
      });

  }
  showReviewCreateUserDialogComponent()
  {
    this.dialog.open(DialogContainerComponent,
      {
        disableClose: true,
        // maxHeight: '90vh',
        minWidth: "40em",
        data: ReviewCreateUserDialogComponent
      });

  }

  showEditUserDialogComponent()
  {
    this.dialog.open(DialogContainerComponent,
      {
        disableClose: true,
        // maxHeight: '90vh',
        minWidth: "42em",
        data: EditUserDialogComponent
      });

  }

  showReviewEditUserDialogComponent()
  {
    this.dialog.open(DialogContainerComponent,
      {
        disableClose: true,
        maxHeight: '95vh',
        minWidth: "40em",
        data: ReviewEditUserDialogComponent
      });

  }
  
  showDeleteUserDialogComponent()
  {
    this.dialog.open(DialogContainerComponent,
      {
        disableClose: true,
        maxHeight: '80vh',
        minWidth: "45em",
        data: DeleteUserDialogComponent
      });

  }

  showResetUserPasswordDialogComponent()
  {
    this.dialog.open(DialogContainerComponent,
      {
        disableClose: true,
        maxHeight: '80vh',
        minWidth: "45em",
        data: ResetUserPasswordDialogComponent
      });

  }

  showSelectClinicsDialogComponent()
  {
    this.dialog.open(DialogContainerComponent,
      {
        disableClose: true,
        maxHeight: '96vh',
        minWidth: "60em",
        data: SelectClinicsDialogComponent
      });
  }
}
